import Yup from 'utils/validation';
import { CampaignType } from 'generated-graphql/types';

export const sourcingSharedSetupApplicationSchema = Yup.object({
  campaignType: Yup.string().oneOf(Object.values(CampaignType)).required(),
  customJobPostingUrl: Yup.string().url('Please enter a valid URL').optional()
});

export type SourcingSharedSetupApplicationFormData = Yup.InferType<
  typeof sourcingSharedSetupApplicationSchema
>;
